import { setCookie, getCookie, delCookie, forceInt, getCurrenLocaleObj  } from '../functions';
import countdown from "countdown";

(function($) {
    // Need to run this code on pages that have the Giveaway Modal so don't want to restrict it just to Giveaway Pages
    // const giveawayPage = $('.GiveawayPage');
    // if (!giveawayPage.length) return;

    // Don't run this code on the Giveaway V2 Enter page
    const giveawayV2Enter = $('.GiveawayV2Enter');
    if (giveawayV2Enter.length) return;

    const wrapperEnter = $('.js-giveaway-entry__wrapper-enter'),
        btnEnter = $('.js-giveaway-entry__wrapper-enter__btn'),
        wrapperEnterOptions = $('.js-giveaway-entry__wrapper-enter-options'),
        btnEnterWithEmail = $('.giveaway-entry__wrapper-enter-options__btn-enter-with-email'),
        wrapperFormWithEmail = $('.js-giveaway-entry__wrapper-form-with-email'),
        btnWithEmail = $('.js-giveaway-entry__wrapper-form-with-email__btn'),
        signUpForm = $('#SignUpForm_GiveawaySignUpForm'),
        signUpFormErrorMessageField = $('#SignUpForm_GiveawaySignUpForm_error'),
        signUpFormSubmitBtn = $('#SignUpForm_GiveawaySignUpForm_action_processSignUpForm'),
        wrapperSignedUp = $('.js-giveaway-signedup'),
        description = $('.js-giveaway-description'),
        giveawayId = forceInt(wrapperSignedUp.data('giveaway-id')),
        currenLocaleObj = getCurrenLocaleObj();

    const actionComplete = function(field) {
        if (field.hasClass('giveaway-signedup__actions-section__actions__action') && !field.hasClass('giveaway-signedup__actions-section__actions__action--complete')) {
            field.addClass('giveaway-signedup__actions-section__actions__action--complete')
                .find('.giveaway-signedup__actions-section__actions__action__status').html('');
        }
    };

    const updateEntriesCount = function() {
        let entriesCount = 0;
        const actionfields = $('.giveaway-signedup__actions-section__actions__action--complete');
        actionfields.each(function() {
            const $this = $(this),
                actionID = forceInt($(this).data('id'));

            const action = giveawayActions.find(action => action.ID === actionID);
            if (action) {
                entriesCount += forceInt(action.NumEntries);
            }
        });

        $('.js-giveaway-entires-count').text(entriesCount);
    };

    const updateEntries = function() {
        if (typeof giveawaySignUpEntries === 'object' && giveawaySignUpEntries && giveawaySignUpEntries.length) {
            giveawaySignUpEntries.forEach(entry => {
                const actionField = $('#giveaway-action-' + entry.ActionID);
                actionComplete(actionField);
            });
        }
    };

    // eventID matches the Conversions API event sent by SignUp::fireSignUpFbEvent() so FB can dedupe them
    const sendFBEvent = function(giveawayTitle, giveawayID, eventID) {
        if (window.FBPixelDefined) {
            fbq('track', 'CompleteRegistration', {
                content_name: 'Giveaway Signed Up',
                giveaway_name: giveawayTitle,
                giveaway_id: giveawayID
            }, (eventID ? { eventID: eventID } : {}));
        }
    };

    const sendGtmSignupEvent = function(giveawayTitle) {
        if (window.GtmDefined) {
            console.log(window.dataLayer);
            window.dataLayer.push({
                'event': 'giveawayEntry'
            });
        }
    };

    btnEnterWithEmail.on('click', function() {
        const $this = $(this);

        wrapperEnterOptions.hide();
        wrapperFormWithEmail.show();
    });

    if (signUpForm.length) {
        signUpForm.parsley().on('form:submit', function() {
            const $this = this.$element,
                formAction = $this.attr('action'),
                formData = $this.serialize();

            signUpFormErrorMessageField.hide();
            signUpFormSubmitBtn.attr('disabled', true);
            $.post('/giveaway-controller/GiveawaySignUpForm/?id=' + giveawayId + '&l=' + currenLocaleObj.locale, formData, function(data) {
                let messages = '';
                if ('status' in data) {
                    if (data.status === 0) {
                        if (data.message !== '') {
                            messages = data.message;
                        }
                    } else if (data.status === 1) {
                        giveawaySignUpEntries = data.entries;
                        wrapperFormWithEmail.hide();
                        wrapperSignedUp.show();
                        $('.js-signup-name').text(data.name);
                        updateEntries();
                        updateEntriesCount();

                        // The Facebook CompleteRegistration event for an AJAX sign up is only sent server-side via
                        // the Conversions API (see SignUp::fireSignUpFbEvent()). The pixel was initialised before the
                        // email was known and ignores a second fbq('init'), so a pixel event here wouldn't have the
                        // email - and as it would reach FB first, the deduped server event (with the email) would be dropped.
                        if (data.sendSignupFBEvent) {
                            sendGtmSignupEvent();
                        }

                        if (description && description.length && !description.hasClass('giveaway-description--hide')) {
                            description.addClass('giveaway-description--hide');
                        }
                    }
                } else {
                    if (data && data.length) {
                        for (let n = 0, m = data.length; n < m; n++) {
                            const dataObject = data[n];
                            if (typeof dataObject === 'object' && 'message' in dataObject) {
                                if (dataObject.message) {
                                    if (messages !== '') messages += '<br>';
                                    messages += dataObject.message;
                                }
                            }
                        }
                    }
                }

                if (messages != '') {
                    signUpFormErrorMessageField.html(messages);
                    signUpFormErrorMessageField.show();
                }

                signUpFormSubmitBtn.removeAttr('disabled');
            }, 'json');

            return false;
        });
    }

    $('.giveaway-signedup__actions-section__actions__action').on('click touch', function () {
        const $this = $(this),
            actionID = forceInt($(this).data('id'));

        if (actionID) {
            const action = giveawayActions.find(action => action.ID === actionID);
            if (action) {
                if (action.Type === 'URL' && action.URL !== '') {
                    window.open(action.URL, '_blank');
                }

                if (!$this.hasClass('giveaway-signedup__actions-section__actions__action--complete')) {
                    // window.location.pathname
                    $.post('/giveaway-controller/index/' + giveawayId + '/?l=' + currenLocaleObj.locale, { actionID: action.ID }, function(data) {
                        if (data.status === 1) {
                            giveawaySignUpEntries = data.entries;
                        }
                    }, 'json');

                    actionComplete($this);
                    updateEntriesCount();
                }
            }
        }
    });

    const giveawaySendSignupFBEvent = $('#giveaway-send-signup-fb-event');
    if (giveawaySendSignupFBEvent.length) {
        const giveawayTitle = giveawaySendSignupFBEvent.data('giveaway-title');
        sendFBEvent(giveawayTitle, forceInt(giveawaySendSignupFBEvent.data('giveaway-id')), giveawaySendSignupFBEvent.data('fb-event-id'));
        sendGtmSignupEvent();
    }

    updateEntries();

    const $giveawayModal = $('#GiveawayModal');
    if ($giveawayModal.length) {
        const $giveawayModalExit = $('.giveaway-modal-exit');
        $giveawayModalExit.on('click', function (e) {
            e.preventDefault();

            $giveawayModal.modal('hide');
        });
    }

    // Giveaway modal
    // let $formSection = $('#giveaway-form');
    // let $congratulationsSection = $('#giveaway-congratulations');
    //
    // if ($congratulationsSection.css('display') !== 'none') {
    //     $formSection.css('display', 'none');
    // }
    //
    // let endDate = new Date($('#date-end').data('end')).getTime();
    //
    // let countdown = setInterval(function () {
    //     let now = new Date().getTime();
    //     let timeRemaining = endDate - now;
    //
    //     if (timeRemaining > 0) {
    //         let days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    //         let hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    //         let minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    //         let seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
    //
    //         days = days < 10 ? '0' + days : days;
    //         hours = hours < 10 ? '0' + hours : hours;
    //         minutes = minutes < 10 ? '0' + minutes : minutes;
    //         seconds = seconds < 10 ? '0' + seconds : seconds;
    //
    //         let timeString = days + ': ' + hours + ': ' + minutes + ':  ' + seconds;
    //         $('#giveaway-time-remaining').text(timeString);
    //     } else {
    //         clearInterval(countdown);
    //         $('#giveaway-time-remaining').text('The draw has ended.');
    //     }
    // }, 1000);
    //

})(jQuery);



// WEBPACK FOOTER //
// ./js/modules/giveawayPage.js